<template lang="pug">
  .flex.items-center(v-clickoutside='close' @keydown.esc='close')
    button(class="lg:hidden" @click="isOpen = !isOpen")
      sw-icon(name="navigation-menu")
    nav.flex.flex-col.absolute.top-2.left-4.right-4.max-h-inset-2.overflow-auto.pt-4.rounded.shadow.bg-white.text-gray-900.transform.origin-top-right.transition-all.ease-out.duration-200(
      :class="isOpen ? 'visible opacity-100 scale-100' : 'invisible opacity-0 scale-90'"
      class="sm:left-auto sm:right-6 sm:w-64 lg:w-auto lg:pt-0 lg:items-center lg:flex-row lg:static lg:space-x-6 lg:bg-transparent lg:shadow-none lg:rounded-0 lg:visible lg:opacity-100 lg:scale-100 lg:overflow-visible"
    )
      button.z-20.h-16.w-16.absolute.top-1.right-0(class="lg:hidden focus:outline-none" @click="isOpen = !isOpen")
        sw-icon(name="close").inline-block
      slot
</template>

<script>
export default {
  name: 'TheNavigation',
  data () {
    return {
      isOpen: false,
    };
  },
  methods: {
    close () {
      this.isOpen = false;
    },
  },
};
</script>
